import React from 'react';

const ProductSummarySkeleton = () => {
  return (
    <div className="px-4 py-5 sm:px-6 border-b border-gray-200 animate-pulse">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="mb-4 md:mb-0">
          <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
          <div className="h-6 bg-gray-200 rounded w-48 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-32"></div>
        </div>

        <div className="flex flex-row space-x-6">
          <div className="text-center flex flex-col justify-end">
            <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>

          <div className="text-center flex flex-col justify-end min-h-[60px]">
            <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSummarySkeleton;